import { IUploadDocumentsStore } from '../pages/load-management/all-loads/upload-and-update/upload-and-update.interface';

export const initialUploadDocumentsState: IUploadDocumentsStore = {
  uploadDocuments: [],
  showUploadPopup: false,
  isUploading: false,
  errors: {}
};
